import { render, staticRenderFns } from "./audits.vue?vue&type=template&id=063bbd35"
import script from "./audits.vue?vue&type=script&lang=js"
export * from "./audits.vue?vue&type=script&lang=js"
import style0 from "./audits.vue?vue&type=style&index=0&id=063bbd35&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports